import { Box, IconButton, Modal, TextField } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { useEffect, useState } from "react";

import { Button, StyledGrid } from "components/simple";
import { color, fontSize, spacingDefaults } from "style/constants";

interface DeleteUserModalProps {
  show: boolean;
  user: string;
  onAccept(): void;
  onCancel(): void;
  isAdmin: boolean;
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  show,
  user,
  onAccept,
  onCancel,
  isAdmin
}: DeleteUserModalProps) => {
  const [disabled, setDisabled] = useState(true);
  const [confirmUser, setConfirmUser] = useState("");

  useEffect(() => {
    setDisabled(confirmUser !== user);
  }, [user, confirmUser]);

  return (
    <Modal onClose={onCancel} open={show}>
      <StyledGrid
        alignItems="center"
        backgroundColor={color.WHITE}
        border={`1px solid ${color.MUTEDGRAY}`}
        borderRadius="8px"
        container
        direction="column"
        left="50%"
        padding={`${spacingDefaults.xlarge} 0`}
        position="absolute"
        top="50%"
        transform="translateX(-50%) translateY(-50%)"
        width="475px"
      >
        <StyledGrid
          item
          position="absolute"
          right={spacingDefaults.xsmall}
          top={spacingDefaults.xsmall}
        >
          <IconButton aria-label="close" key="close" onClick={onCancel}>
            <Close />
          </IconButton>
        </StyledGrid>

        <StyledGrid
          container
          direction="column"
          item
          justifyContent="center"
          padding={`0 ${spacingDefaults.xlarge}`}
        >
          <Box fontSize={fontSize.large} textAlign="center">
            Confirm Deletion
          </Box>

          <Box marginTop={spacingDefaults.normal} textAlign="center">
            This action is <strong>destructive</strong> and <strong>not reversible</strong>. Type
            the name below to proceed.
          </Box>

          {isAdmin && (
            <Box marginTop={spacingDefaults.normal} textAlign="center">
              You <strong>must</strong> ensure that there are no upcoming coaching sessions
              associated with this user, otherwise the SUMO synchronization will cause issues.
            </Box>
          )}

          <Box
            fontSize={fontSize.medium}
            margin={`${spacingDefaults.normal} 0`}
            paddingLeft="13px"
            textAlign="center"
          >
            <strong>{user}</strong>
          </Box>

          <TextField
            inputProps={{
              "data-testid": "confirm-delete",
              style: {
                fontSize: fontSize.medium,
                fontWeight: "bold",
                textAlign: "center"
              }
            }}
            onChange={event => setConfirmUser(event.target.value)}
            value={confirmUser}
          />
        </StyledGrid>

        <StyledGrid item marginTop={spacingDefaults.large}>
          <Button
            disabled={disabled}
            onClick={() => {
              setConfirmUser("");
              onAccept();
            }}
            warning
            width="250px"
          >
            Delete User
          </Button>
        </StyledGrid>

        <StyledGrid item marginTop={spacingDefaults.xsmall}>
          <Button
            inverted
            onClick={() => {
              setConfirmUser("");
              onCancel();
            }}
            width="250px"
          >
            Cancel
          </Button>
        </StyledGrid>
      </StyledGrid>
    </Modal>
  );
};

export default DeleteUserModal;
